import { ProjectType } from './project-type';
import { ProjectHeadVO } from './vo/project.vo';

type CheckableProjectType = ProjectType | ProjectHeadVO | undefined;

export class IsProjectType {
  public static admin(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'ADMIN';
  }

  public static mountingRailOrFreeMounting(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'MOUNTING_RAIL', 'FREE_MOUNTING');
  }

  public static mounting(projectType: CheckableProjectType): boolean {
    return this.visibleMountingRail(projectType) || this.invisibleMountingRail(projectType);
  }

  public static visibleMountingRail(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'MOUNTING_RAIL';
  }

  public static invisibleMountingRail(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'FREE_MOUNTING', 'CIRCUIT_BOARD', 'MCS', 'GDS', 'SPEEDWAY', 'LTL', 'SPLICING_CONNECTOR_221')
  }

  public static freeMounting(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'FREE_MOUNTING', 'CIRCUIT_BOARD');
  }

  public static controlCabinet(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'FREE_MOUNTING', 'MOUNTING_RAIL');
  }

  public static mcs(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'MCS';
  }

  public static gds(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'GDS';
  }

  public static mcsGds(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'MCS', 'GDS');
  }

  public static speedway(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'SPEEDWAY';
  }

  public static markingSystem(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'MARKINGSYSTEM';
  }

  public static xCom(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'XCOM';
  }

  public static splicingConnector221(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'SPLICING_CONNECTOR_221';
  }

  public static ltl(projectType: CheckableProjectType): boolean {
    return this.getType(projectType) === 'LTL';
  }

  public static withBaseArticle(projectType: CheckableProjectType): boolean {
    return this.among(projectType, 'MCS', 'GDS', 'LTL', 'SPLICING_CONNECTOR_221');
  }

  public static among(projectType: CheckableProjectType, ...projectTypes: (ProjectType | undefined)[]) {
    return projectType ? projectTypes.includes(this.getType(projectType)) : false;
  }

  private static getType(value: CheckableProjectType): ProjectType | undefined {
    return typeof value == 'string' ? value : value?.projectType;
  }
}
